<div class="modal fade" id="{{id}}" aria-hidden="true"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-info">
                <h5 class="modal-title" style="color: white;" id="exampleModalToggleLabel">{{message}}</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-footer" style="justify-content: center;">
                @for(option of options; track option.name) {
                    <button class="btn btn-info" data-bs-dismiss="modal" (click)="emit(option.value)">{{option.name}}</button>
                }
            </div>
        </div>
    </div>
</div>
